export default __webpack_public_path__ + "static/media/import_export.ca54d50e.svg";